export default __webpack_public_path__ + "static/media/shopping-basket-1.3019ef0c.png";